import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const authAdyenContract = c.router(
  {
    makeAdyenPaymentRequest: {
      method: 'POST',
      path: '/make-payment-request',
      body: z.object({
        adyenPaymentSessionId: z.string(),
        sessionId: z.string(),
        adyenState: z.any(),
        queryParams: z.string(),
      }),
      responses: {
        200: z.object({
          resultCode: z.string(),
          refusalReason: z.optional(z.string()),
          action: z.any(),
        }),
      },
      summary: 'Make payment via adyen',
    },
    getAdyenPaymentDetails: {
      method: 'POST',
      path: '/get-payment-details',
      body: z.object({
        adyenState: z.any(),
      }),
      responses: {
        200: z.object({
          resultCode: z.optional(z.string()),
          refusalReason: z.optional(z.string()),
        }),
      },
      summary: 'Get payment details',
    },
    getAdyenPaymentStatus: {
      method: 'GET',
      path: '/get-payment-status',
      query: z.object({
        adyenPaymentSessionId: z.string(),
      }),
      responses: {
        200: z.object({
          status: z.string().nullable(),
        }),
        404: c.type<{ message: string }>(),
      },
    },
    getAdyenPaymentRefusalReason: {
      method: 'GET',
      path: '/get-payment-refusal-reason',
      query: z.object({
        adyenPaymentSessionId: z.string(),
      }),
      responses: {
        200: z.object({
          reason: z.optional(z.string()),
        }),
      },
      summary: 'Get payment refusal reason',
    },

    createApplePayMerchantSession: {
      method: 'POST',
      path: '/applepay-merchant-session/create',
      body: z.object({
        validationUrl: z.string(),
      }),
      responses: {
        200: z.any(),
      },
      summary: 'Get Apple pay merchant session',
    },
  },
  {
    pathPrefix: '/auth',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  }
);
